import PayrollDeductionCreateComponents from "../components/PayrollDeductionCreate";
import useDeduction from "../hooks/useDeduction";

const PayrollDeductionCreate = () => {
  const useDeductionProps = useDeduction();
  return <PayrollDeductionCreateComponents {...useDeductionProps} />;
};

export default PayrollDeductionCreate;
